<!--
    Note: Detailseiten sind immer ähnlich aufgebaut!
-->
<script>
    import HeaderBar from "../components/header/HeaderBar.svelte";
    import { createEventDispatcher } from "svelte";
    import GeneralLayout from "../common/GeneralLayout.svelte";
    import BackButton from "../common/buttons/BackButton.svelte";

    const dispatcher = createEventDispatcher();

    export let title;
    export let titleImage;
    export let shortDescription;
    export let description;
    // headerActions: 'SHARE', 'SEARCH', 'CLOSE'
    export let headerAction;
    export let backgroundColor;

    export let slotPadding = true;
</script>

<main style="background-color: {backgroundColor}">
    <div class="display-small">
        <!-- Header Bar -->
        <HeaderBar
            on:actionClicked={() => dispatcher("actionClicked")}
            {title}
            share={headerAction === "SHARE"}
            close={headerAction === "CLOSE"}
            {backgroundColor}
        />
    </div>
    <GeneralLayout>
        <div style="width: 100%" slot="firstSegment">
            <div class="display-big">
                <HeaderBar
                    on:actionClicked={() => dispatcher("actionClicked")}
                    hideSeperator
                    share={headerAction === "SHARE"}
                    close={headerAction === "CLOSE"}
                    {backgroundColor}
                />
            </div>
            <!-- Title Image -->
            {#if titleImage}
                <div class="title-image-wrapper">
                    <img src={titleImage} alt={title} class="title-image" />
                </div>
            {/if}
            <!-- Page Title (topTitle, mainTitle, subTitle) -->
            <div class="title-wrapper">
                <slot name="preTitleArea" />
                <div class="page-title">
                    <div class="headline-l title-text">{title}</div>
                </div>
                <slot name="subTitleArea" />
            </div>
        </div>
        <div slot="secondSegment">
            <div class="slideshow-wrapper">
                <slot name="imageSlideshow" />
            </div>
            <!-- Content (shortDescription, description) -->
            <div class="content">
                {#if shortDescription}
                    <div
                        style="padding-right: 16px;"
                        class="short-description headline-xs"
                    >
                        {shortDescription}
                    </div>
                {/if}
                {#if description}
                    <div class="text-l" style="padding-top:16px">
                        {description}
                    </div>
                {/if}
                <slot name="content" />
            </div>
            <div class:sub-description-wrapper={slotPadding}>
                <slot name="subDescriptionArea" />
            </div>
            <div class="slideshow-wrapper">
                <slot name="shortcutSlideshow" />
            </div>
            <!-- Optional Floating Button -->
            <div class="floating-button-placeholder" />
            <div class="floating-button">
                <slot name="floatingButton" />
            </div>
        </div>
    </GeneralLayout>
</main>

<style>
    .short-description {
        margin-top: 16px;
        margin-bottom: 32px;
    }

    .title-image {
        width: 100%;
        height: auto;
    }

    .title-image-wrapper {
        padding: 0px 16px 8px 16px;
    }

    .slideshow-wrapper {
        margin: 0px 0px 8px 16px;
    }

    .title-wrapper {
        padding: 16px 16px 4px 16px;
    }

    .sub-description-wrapper {
        padding: 0px 16px 0px 16px;
    }

    .page-title {
        margin-top: 4px;
    }

    .content {
        padding: 0px 16px 8px 16px;
    }

    @media only screen and (max-width: 1439px) {
        .floating-button {
            position: fixed;
            bottom: 8px;
            left: 16px;
            right: 16px;
        }

        .floating-button-placeholder {
            height: 96px;
        }
    }

    .display-big {
        display: none;
    }

    @media only screen and (min-width: 1440px) {
        .floating-button {
            position: fixed;
            bottom: 48px;
            left: 32px;
            right: 67%;
            max-width: 596px;
        }

        .floating-button-placeholder {
            height: 0px;
        }

        .content {
            padding: 0px 16px 0px 16px;
            display: grid;
            grid-template-columns: 1fr 2.5fr;
        }

        .title-text {
            font-size: 72px;
        }

        .display-small {
            display: none;
        }

        .display-big {
            display: flex;
        }
        .slideshow-wrapper {
            margin: 0px 0px 0px 16px;
            padding-top: 72px;
        }

        .title-image-wrapper {
            padding: 10px 16px 8px 16px;
        }
    }
</style>
